module.exports = __webpack_public_path__ + "static/media/asinzen2019.94f6b59c.png";